import moment from 'moment';

const normalizeDate = (input) => {  
  return moment.utc(moment(input).format('YYYY-MM-DD')).utcOffset(0);
};

export default normalizeDate;
